import gql from 'graphql-tag';

import integrationItemFragment from './integrationItemFragment';

export const integrationEmailBodyFragment = gql`
  fragment integrationEmailBodyFragment on IntegrationEmailBody {
    dokkioClass
    html
    attachments {
      ...integrationItemFragment
    }
  }
  ${integrationItemFragment}
`;
export default integrationEmailBodyFragment;
